import { MAX_TICKET_TITLE_LENGTH } from "@src/cloud-connect/support/constants/constants";

const pageNameKey = "addRequestTechnicalSupportDrawerModal";

export const addRequestTechnicalSupportDrawerModalEn = {
  [pageNameKey]: {
    imageRemoveAlt: "Remove image",
    imagePickerLabel: "Attach images",
    imageTooMany: "You can select up to 3 images.",
    imageSizeTooLarge: "Each image must be smaller than 5MB.",
    imageInvalidType: "Please select image files (JPEG, PNG or WebP).",
    title: "Request Technical Support",
    supportDetails: "Support Details",
    machine: "Machine",
    issueTitle: "Issue Title",
    issueTitlePlaceholder: "Describe the issue briefly",
    issueDetails: "Issue Details",
    issueDetailsPlaceholder: "Provide more details about the issue",
    requestButton: "Request Remote Technical Support",
    submitErrorMessage:
      "An error occurred while submitting your request. Please try again.",
    issueTitleTooLongError: `Issue title can be ${MAX_TICKET_TITLE_LENGTH} characters at most.`,
  },
};

export const addRequestTechnicalSupportDrawerModalPtBr = {
  [pageNameKey]: {
    imageRemoveAlt: "Remover imagem",
    imagePickerLabel: "Anexar imagens",
    imageTooMany: "Você pode selecionar até 3 imagens.",
    imageSizeTooLarge: "Cada imagem deve ter menos de 5MB.",
    imageInvalidType: "Selecione arquivos de imagem (JPEG, PNG ou WebP).",
    title: "Solicitar suporte técnico",
    supportDetails: "Detalhes do suporte",
    machine: "Máquina",
    issueTitle: "Título do problema",
    issueTitlePlaceholder: "Descreva o problema brevemente",
    issueDetails: "Detalhes do problema",
    issueDetailsPlaceholder: "Forneça mais detalhes sobre o problema",
    requestButton: "Solicitar suporte técnico remoto",
    submitErrorMessage:
      "Ocorreu um erro ao enviar sua solicitação. Tente novamente.",
    issueTitleTooLongError: `Issue title can be ${MAX_TICKET_TITLE_LENGTH} characters at most.`,
  },
};

export const addRequestTechnicalSupportDrawerModalDe = {
  [pageNameKey]: {
    imageRemoveAlt: "Bild entfernen",
    imagePickerLabel: "Bilder anhängen",
    imageTooMany: "Du kannst bis zu 3 Bilder auswählen.",
    imageSizeTooLarge: "Jedes Bild muss kleiner als 5MB sein.",
    imageInvalidType: "Bitte wähle Bilddateien (JPEG, PNG oder WebP) aus.",
    title: "Technischen Support anfordern",
    supportDetails: "Support-Details",
    machine: "Maschine",
    issueTitle: "Problemtitel",
    issueTitlePlaceholder: "Problem kurz beschreiben",
    issueDetails: "Problemdetails",
    issueDetailsPlaceholder: "Weitere Details zum Problem angeben",
    requestButton: "Remote-Technischen Support anfordern",
    submitErrorMessage:
      "Beim Senden Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    issueTitleTooLongError: `Der Problemtitel darf ${MAX_TICKET_TITLE_LENGTH} Zeichen nicht überschreiten.`,
  },
};

export const addRequestTechnicalSupportDrawerModalZhHans = {
  [pageNameKey]: {
    imageRemoveAlt: "移除图片",
    imagePickerLabel: "附加图片",
    imageTooMany: "最多可以选择3张图片。",
    imageSizeTooLarge: "每张图片必须小于5MB。",
    imageInvalidType: "请选择图片文件（JPEG、PNG 或 WebP）。",
    title: "请求技术支持",
    supportDetails: "支持详情",
    machine: "机器",
    issueTitle: "问题标题",
    issueTitlePlaceholder: "请简要描述问题。",
    issueDetails: "问题详情",
    issueDetailsPlaceholder: "提供更多问题详情",
    requestButton: "请求远程技术支持",
    submitErrorMessage: "提交请求时发生错误。请再试一次。",
    issueTitleTooLongError: "问题标题不能超过255个字符。",
  },
};

export const addRequestTechnicalSupportDrawerModalIt = {
  [pageNameKey]: {
    imageRemoveAlt: "Rimuovi immagine",
    imagePickerLabel: "Allega immagini",
    imageTooMany: "Puoi selezionare fino a 3 immagini.",
    imageSizeTooLarge: "Ogni immagine deve essere inferiore a 5MB.",
    imageInvalidType: "Seleziona file immagine (JPEG, PNG o WebP).",
    title: "Richiedi supporto tecnico",
    supportDetails: "Dettagli per il supporto",
    machine: "Macchina",
    issueTitle: "Titolo del problema",
    issueTitlePlaceholder: "Descrivi brevemente il problema",
    issueDetails: "Dettagli del problema",
    issueDetailsPlaceholder: "Fornisci ulteriori dettagli sul problema",
    requestButton: "Richiedi Supporto Tecnico Remoto",
    submitErrorMessage:
      "Si è verificato un errore durante l'invio della richiesta. Riprova.",
    issueTitleTooLongError: `Il titolo del problema non può superare i ${MAX_TICKET_TITLE_LENGTH} caratteri.`,
  },
};

export const addRequestTechnicalSupportDrawerModalEs = {
  [pageNameKey]: {
    imageRemoveAlt: "Eliminar imagen",
    imagePickerLabel: "Adjuntar imágenes",
    imageTooMany: "Puedes seleccionar hasta 3 imágenes.",
    imageSizeTooLarge: "Cada imagen debe tener menos de 5MB.",
    imageInvalidType: "Selecciona archivos de imagen (JPEG, PNG o WebP).",
    title: "Solicitar soporte técnico",
    supportDetails: "Detalles de soporte",
    machine: "máquina",
    issueTitle: "Título del problema",
    issueTitlePlaceholder: "Describe brevemente el problema",
    issueDetails: "Detalles del problema",
    issueDetailsPlaceholder: "Proporciona más detalles sobre el problema",
    requestButton: "Solicitar soporte técnico remoto",
    submitErrorMessage:
      "Se produjo un error al enviar tu solicitud. Inténtalo de nuevo.",
    issueTitleTooLongError: `Issue title can be ${MAX_TICKET_TITLE_LENGTH} characters at most.`,
  },
};

export const addRequestTechnicalSupportDrawerModalNl = {
  [pageNameKey]: {
    imageRemoveAlt: "Afbeelding verwijderen",
    imagePickerLabel: "Afbeeldingen bijvoegen",
    imageTooMany: "Je kunt maximaal 3 afbeeldingen selecteren.",
    imageSizeTooLarge: "Elke afbeelding moet kleiner zijn dan 5MB.",
    imageInvalidType: "Selecteer afbeeldingsbestanden (JPEG, PNG of WebP).",
    issueDetails: "Probleemdetails",
    issueDetailsPlaceholder: "Geef meer details over het probleem",
    issueTitle: "Probleemtitel",
    issueTitlePlaceholder: "Beschrijf het probleem kort",
    issueTitleTooLongError:
      "De probleemtitel mag maximaal ${MAX_TICKET_TITLE_LENGTH} tekens bevatten.",
    machine: "Machine",
    requestButton: "Externe technische-support aanvragen",
    submitErrorMessage:
      "Er is een fout opgetreden bij het verzenden van uw aanvraag. Probeer het opnieuw.",
    supportDetails: "Supportdetails",
    title: "Technische-support aanvragen",
  },
};

export const addRequestTechnicalSupportDrawerModalTr = {
  [pageNameKey]: {
    imageRemoveAlt: "Görseli kaldır",
    imagePickerLabel: "Görsel ekle",
    imageTooMany: "En fazla 3 görsel seçebilirsiniz.",
    imageSizeTooLarge: "Her görsel 5 MB'tan küçük olmalıdır.",
    imageInvalidType: "Lütfen JPEG, PNG veya WebP biçiminde görsel seçin.",
    issueDetails: "Sorun Ayrıntıları",
    issueDetailsPlaceholder: "Sorunla ilgili daha fazla ayrıntı sağlayın",
    issueTitle: "Sayı Başlığı",
    issueTitlePlaceholder: "Sorunu kısaca açıklayın",
    issueTitleTooLongError:
      "Sayı başlığı en fazla ${MAX_TICKET_TITLE_LENGTH} karakterden oluşabilir.",
    machine: "Makine",
    requestButton: "Uzaktan Teknik Destek Talebi",
    submitErrorMessage:
      "İsteğiniz gönderilirken bir hata oluştu. Lütfen tekrar deneyin.",
    supportDetails: "Destek Ayrıntıları",
    title: "Teknik Destek Talebi",
  },
};
